import { Component, OnInit } from '@angular/core';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';

@Component({
  selector: 'app-alis-sso',
  templateUrl: './alis-sso.component.html',
  styleUrls: ['./alis-sso.component.scss']
})
export class ALISSSOComponent implements OnInit {
  

constructor(public ALISservice:GenesysCloudService) { }

  
  ngOnInit() {
    /**
     * @author Vamsikrishna
     * CCR3-16988
     */
    const query = new URLSearchParams(window.location.search);
    if (window.opener && sessionStorage.getItem('ALIS_token_recovery') !== 'true' && (query.has('code') || query.has('error'))) {
      window.opener.postMessage({ name: 'gc_auth_popup', type: 'message', search: window.location.search }, window.location.origin);
      return;
    }
    sessionStorage.setItem('ALIS_token_recovery', 'true');
    this.ALISservice.loginGenesysPopUp();
  }

}
